import { trackError } from '@src/core/sentry';

export const arcDownloadFile = (fileURL: string, fileName: string) => {
  try {
    const a = document.createElement('a');
    a.href = fileURL;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(fileURL);
  } catch (e: unknown) {
    trackError(e instanceof Error ? e : new Error(String(e)), {
      code: 'FE_0006',
      extra: { fileName },
    });
    throw new Error('Invalid file');
  }
};
  